import bottomLeft from '../../assets/happyNY2026/bottomLeft.svg';
import logoHex from '../../assets/happyNY2026/logo-hex.svg';
import logoRkt from '../../assets/happyNY2026/logo-rkt.svg';
import logoRuscomtech from '../../assets/happyNY2026/logo-ruscomtech.svg';
import one from '../../assets/happyNY2026/one.svg';
import three from '../../assets/happyNY2026/three.svg';
import four from '../../assets/happyNY2026/four.svg';
import five from '../../assets/happyNY2026/five.svg';
import six from '../../assets/happyNY2026/six.svg';
import seven from '../../assets/happyNY2026/seven.svg';
import ka from '../../assets/happyNY2026/ka.svg';
import kaText from '../../assets/happyNY2026/kaText.svg';

const RKTComponent = () => {
  return (
    <div className="flex flex-row items-center justify-center md:gap-[32px] gap-[16px] md:translate-y-[-10px] xs:translate-y-[-50px] translate-y-[-90px] md:translate-x-[10px] lg:translate-x-[50px] w-full ">
      <img alt="" src={logoHex} className="w-[130px] h-[153px]" />    

      <div className="flex flex-col items-center justify-center md:gap-[35px] gap-[20px]">
        <img alt="" src={logoRkt} className="w-[139px] h-[59px]" />
        <img alt="" src={logoRuscomtech} className="w-[134px] h-[8px]" />
      </div>
    </div> 
  );
};


const KAComponent = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-[32px] xl:translate-y-[-80px] md:translate-y-[-100px] translate-y-[-60px] lg:translate-x-[100px] translate-x-[0px]">
      <img alt="" src={ka} className="w-[clamp(90px,12vw,97px)] h-auto" />
      <img alt="" src={kaText} className="w-full h-auto" />
    </div>
  );
};

const Four = () => {
  return (
    <section className="w-full ">
      <div className="relative bg-[#EFF2FB] mx-auto w-full max-w-[1920px] h-[952px]">
        
        <div className="w-full grid grid-cols-3 overflow-hidden h-[250px] md:h-[350px] xl:h-[350px]">
        {/* Top-left decoration */}
        <div className="flex flex-row item-start justify-start gap-[32px]">
          <img alt="" src={three} className="w-[200px] xl:w-[263px] h-auto translate-y-[0px] lg:translate-x-[70px] translate-x-[0px] hidden md:block" />
        </div>

        {/* Top-right decoration (inside the white container) */}
        <div className=" flex items-end flex flex-row">
          <KAComponent />
        </div>

        <div className="flex flex-row">
          <img alt="" src={four} className="w-[183px] h-auto xl:translate-y-[-140px] lg:translate-y-[-100px] xl:translate-x-[-30px] lg:translate-x-[150px] md:translate-x-[40px] hidden md:block" />              
          <img alt="" src={five} className="w-[254px] h-auto translate-y-[60px] xl:translate-y-[45px] translate-x-[0px] hidden xl:block" />              
        </div>
        
        </div>
        

        <div className="flex flex-col items-center justify-center w-full px-4 xl:px-[92px]">
            {/* Content */}
            <h1 className="w-full text-black text-center uppercase font-normal font-circeRounded text-[40px] xl:text-[64px] lg:leading-[2.1]">
            С Новым годом!
            </h1>

            <h3 className="w-full text-black text-center font-normal font-circeRounded text-[32px] xl:text-[40px] leading-[1.1] mt-[20px] md:mt-[20px] xl:mt-[0px]">
            Заряд для вас — стабильность для систем
            </h3>

            <div className="mt-[36px] max-w-[1176px] text-black font-normal font-circeRounded text-[16px] lg:text-[22px] xl:text-[24px] leading-[140%] text-center">
            <p>
            Наш «Ключ-АСТРОМ» обеспечивает, чтобы ваши приложения работали на полную мощность. <br className="hidden lg:block" />
            Желаем в 2026 году неугасаемой энергии и дарим пауэрбанк как символ нашей поддержки. Пусть ваши устройства всегда будут заряжены, а бизнес-процессы — под надёжным контролем.

            </p>
            
            </div>
        </div>
        

      <div className="h-[280px] w-full overflow-hidden grid grid-cols-1 md:grid-cols-2">
        {/* Bottom-left decoration */}
          <div className=" flex flex-row item-start justify-start gap-[32px] hidden md:flex">
            <img alt="" src={six} className="w-[263px] h-[263px] md:translate-y-[30px] xl:translate-y-[0px] translate-x-[-50px]" />
            <img alt="" src={seven} className="w-[167px] h-[167px] translate-y-[130px] translate-x-[80px] xl:translate-x-[40px] hidden lg:block" />

          </div>

          {/* Bottom-right */}
          <div className=" flex items-end justify-start lg:justify-center">
            <RKTComponent />
            <img alt="" src={one} className="w-[300px] h-auto translate-y-[35px] translate-x-[100px] hidden xl:block" />              
          </div>
      </div>
    </div>
  </section>
);
};

export default Four;